import L from "leaflet";

/** L.map() mit sicherem Entfernen: Leaflet stürzt ab („can't access property _leaflet_pos“), wenn eine Karte mitten in einer Zoom-Animation entfernt wird → bis zoomend warten. */
export const createMap = (el, options) => {
  const map = L.map(el, options);
  let zooming = false;
  map.on("zoomanim", () => { zooming = true; });
  map.on("zoomend", () => { zooming = false; });
  map.safeRemove = () => {
    let done = false;
    const run = () => { if (!done) { done = true; map.remove(); } };
    if (zooming) { map.once("zoomend", run); setTimeout(run, 400); } else run();
  };
  return map;
};
